import axios from 'axios';
import React, { useState } from 'react';
import { Form, Button, Container, Row, Col, Card, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { BASE_URL } from '../../components/APi';
import Sidebar from '../../components/Sidebar';
import Navbar from '../../components/Navbar';

function AddCoupon() {
  const [couponCode, setCouponCode] = useState('');
  const [expiryDate, setExpiryDate] = useState('');
  const [couponType, setCouponType] = useState('UNLIMITED');
  const [couponStatus, setCouponStatus] = useState('ACTIVE');
  const [usageLimit, setUsageLimit] = useState(0);
  const [percentage, setPercentage] = useState(50.0);
  const [loading, setLoading] = useState(false);
  const navgigate = useNavigate();
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const params = {
      coupenCode: couponCode?.trim(),
      expiry_date: expiryDate,
      coupentype: couponType,
      coupenStatus: couponStatus,
      usageLimit: usageLimit,
      percentage: percentage,
    };

    try {
      const response = await axios.post(`${BASE_URL}/coupen/post`, params, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      setLoading(false);
      if (response.status === 200) {
        alert('Coupon added successfully!');
        navgigate('/Copuontable/1');
      } else {
        alert('Failed to add coupon');
      }
    } catch (error) {
      setLoading(false);
      console.error('Error:', error);
      alert('An error occurred while adding the coupon');
    }
  };

  // Update usage limit when coupon type changes
  const handleCouponTypeChange = (e) => {
    const newCouponType = e.target.value;
    setCouponType(newCouponType);

    if (newCouponType === 'MULTIUSER') {
      setUsageLimit(0); // Set usage limit to 0 if MULTIUSER is selected
    }
  };

  return (
    <>
      {/* <Container className=" " style={{ minHeight: '90vh',  }}> */}
      <Card style={{ width: '100%', margin: '0 auto', boxShadow: '0 8px 32px rgba(0,0,0,0.10)', borderRadius: '24px', border: 'none', padding: '2rem 1.5rem' }}>
        <div style={{ marginBottom: '1.5rem' }}>
          <Card.Title style={{ fontSize: '1.25rem', fontWeight: 'bold', color: '#1e293b', marginBottom: 0 }}>Add Coupon</Card.Title>
          <Card.Subtitle className="mb-1 text-muted" style={{ fontSize: '1rem' }}>
            Create a new discount coupon for your customers
          </Card.Subtitle>
        </div>
        <div style={{ marginBottom: '2rem', color: '#64748b', fontSize: '1.05rem' }}>
          Fill in the details below to generate a coupon code. You can set the type, status, usage limit, and discount percentage.
        </div>
        <Form onSubmit={handleSubmit}>
          <Row className="mb-3">
            <Col md={6} className="mb-3 mb-md-0">
              <Form.Group controlId="couponCode">
                <Form.Label>Coupon Code</Form.Label>
               <Form.Control
  type="text"
  value={couponCode}
 onChange={(e) => {
    const value = e.target.value.replace(/[^A-Za-z0-9-]/g, "");
    setCouponCode(value);
  }}
  pattern="^[A-Za-z0-9-]+$"
  title="Only letters, numbers, and hyphens (-) are allowed."
  placeholder="Allowed: A-Z a-z 0-9 -"
/>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="expiryDate">
                <Form.Label>Expiry Date</Form.Label>
                <Form.Control
                  type="datetime-local"
                  value={expiryDate}
                  onChange={(e) => setExpiryDate(e.target.value)}
                  required
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={6} className="mb-3 mb-md-0">
              <Form.Group controlId="couponType">
                <Form.Label>Coupon Type</Form.Label>
                <Form.Select
                  value={couponType}
                  onChange={handleCouponTypeChange}
                >
                  <option value="MULTIUSER">MULTIUSER</option>
                  <option value="UNLIMITED">UNLIMITED</option>
                  <option value="LIMITED">LIMITED</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="couponStatus">
                <Form.Label>Coupon Status</Form.Label>
                <Form.Select
                  value={couponStatus}
                  onChange={(e) => setCouponStatus(e.target.value)}
                >
                  <option value="ACTIVE">ACTIVE</option>
                  <option value="INACTIVE">INACTIVE</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
          <Row className="mb-3">
            <Col md={6} className="mb-3 mb-md-0">
              <Form.Group controlId="usageLimit">
                <Form.Label>Usage Limit</Form.Label>
                <Form.Control
                  type="number"
                  value={usageLimit}
                  onChange={(e) => setUsageLimit(e.target.value)}
                  disabled={couponType === 'MULTIUSER' || couponType === 'UNLIMITED'}
                  placeholder="Enter usage limit"
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group controlId="percentage">
                <Form.Label>Discount Percentage</Form.Label>
                <Form.Control
                  type="number"
                  step="0.01"
                  max='100'
                  value={percentage}
                  onChange={(e) => setPercentage(e.target.value)}
                  required
                  placeholder="e.g. 50 for 50%"
                />
              </Form.Group>
            </Col>
          </Row>
          <div className="d-flex justify-content-end align-items-center mt-4">
            <Button variant="primary" type="submit" disabled={loading} style={{ minWidth: '140px', fontWeight: 'bold', fontSize: '1.1rem', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0,123,255,0.12)' }}>
              {loading ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                    className="me-2"
                  />
                  Adding...
                </>
              ) : (
                'Add Coupon'
              )}
            </Button>
          </div>
        </Form>
      </Card>
      {/* </Container> */}
    </>
  );
}

export default AddCoupon;
